export const whatsAppLinkFormatter = (phoneNumber: string, subject: string) => {
  // Remove plus signs, spaces, invisible chars, and dashes
  phoneNumber = phoneNumber.replace(/[+\s\-\u200B-\u200D\uFEFF]/g, '');
  if (phoneNumber.startsWith('05')) {
    phoneNumber = `972${phoneNumber.slice(1)}`;
  }
  return `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(subject)}`;
};
